<script>
    import DateFilter from './DateFilter.svelte';
    import FilterParl from './FilterParl.svelte';
    import FilterEP from './FilterEP.svelte';
    import FilterPers from './FilterPers.svelte';

    export let filter_location = '';
</script>

<div class="checkboxes">
    <DateFilter/>

    <hr id="doc-filter-hr">

    <h3>Parlementaire documenten</h3>
    <FilterParl show_counts=true filter_location={filter_location}/>

    <h3>Europees Parlement</h3>
    <FilterEP show_counts=true filter_location={filter_location}/>

    <h3>Persberichten</h3>
    <FilterPers show_counts=true filter_location={filter_location}/>
</div>

<style lang="scss">
    #doc-filter-hr {
        border-top: 1px solid var(--light-blue-color4) !important;
        margin-bottom: 26px;
    }
</style>
